import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import htmlclass from "./htmlclass.module";
import invoice from "./invoice"
import queryparams from "./queryparams";
import monthlydata from "./monthlydata";
import companies from "./companies";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    htmlclass,
    invoice,
    queryparams,
    monthlydata, 
    companies
  },
});
